/**
 * openExternalUrl — sortir de l'app vers une page web, du même geste partout.
 *
 * Sur le web c'est un onglet, ailleurs le navigateur intégré (`CancelPaymentScreen.js:24-31`).
 * Pur : aucun état, aucun hook — un écran peut l'appeler directement.
 *
 * Un appelant qui doit ouvrir l'onglet AVANT son appel réseau (le portail Stripe : une session
 * créée puis ouverte se fait avaler par le bloqueur de pop-ups) garde son onglet pré-ouvert et
 * n'utilise ceci que pour le cas sans onglet en attente.
 */
import { Platform } from "react-native"
import * as WebBrowser from "expo-web-browser"

export const IS_WEB = Platform.OS === "web"

export function openExternalUrl(url: string | null | undefined): void {
    if (!url) return
    if (IS_WEB && typeof window !== "undefined") {
        window.open(url)
        return
    }
    void WebBrowser.openBrowserAsync(url)
}
